import { RefObject, TextareaHTMLAttributes } from 'react';
import classNames from 'classnames';
import { componentSizeVariantsEnum } from 'src/constants/common.constants';
import './textArea2.scss';

type TTextArea2Props = {
  variant?: componentSizeVariantsEnum;
  inputRef?: RefObject<HTMLTextAreaElement>;
  createProgramStep?: any;
  textAreaStyle?: any;
  hasError?: boolean;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

/**
 * Props for the TextArea2 component - Version 2 Modern Design.
 * @typedef {Object} TTextArea2Props
 * @param {componentSizeVariantsEnum} [variant] - The variant of the text area.
 * @param {boolean} [hasError] - Whether the text area has an error state.
 * @param {TextareaHTMLAttributes<HTMLTextAreaElement>} [HTMLTextAreaElement] - HTML attributes of the text area element.
 */
const TextArea2 = ({
  className,
  value,
  disabled,
  variant = componentSizeVariantsEnum.LARGE,
  inputRef,
  createProgramStep,
  textAreaStyle,
  hasError = false,
  ...rest
}: TTextArea2Props) => {
  const dynamicStyles = textAreaStyle || (createProgramStep ? { maxHeight: '48px' } : {});

  return (
    <div
      className={classNames(
        className, 
        'textarea-component-v2',
        `textarea-component-v2--${variant}`,
        {
          'textarea-component-v2--disabled': disabled,
          'textarea-component-v2--error': hasError
        }
      )}
      style={dynamicStyles}
    >
      <textarea
        {...rest}
        value={value}
        disabled={disabled}
        className="textarea-component-v2__textarea"
        ref={inputRef}
      />
    </div>
  );
};

export default TextArea2;
